module.exports = __webpack_public_path__ + "static/media/5-7.42e634b1.webp";